import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_SAP_AI_IMAGE_PROMPT = createFcmDetails('sap_ai_image_prompt', {
	owner: 'starfish',
	context: 'Start A Petition Page - Media Step',
	description:
		'Configuration for SAP AI Image Prompt step: isEnabled determines whether the AI Image generation is enabled for users. If it is enabled, systemPrompt specifies system prompt sent to ChatGPT and mainPrompt is the user prompt. Replacements are string replacements in the main prompt. The options provide overrides for the conversations and image API calls.',
	template: {
		isEnabled: true,
		systemPrompt:
			'You work for Change.org. Your role is to write a prompt for an AI to create the best possible image possible for a given petition. You only return the prompt and nothing else. The prompt should be clear that there should be no text on the image. The prompt should ensure that the image will not have too many elements and be very easy to read and understand for viewers.',
		mainPrompt: {
			replacements: ['petitionTitle', 'petitionContent'],
			text: 'This is the petition title: %{petitionTitle}. Here is the petition content: %{petitionContent}.',
		},
		options: {
			conversationsModel: 'gpt-4',
			imageModel: '"dall-e-3"',
			imageSize: '1024x1024',
		},
	},
	import: false,
});
